export default "__VITE_ASSET__BVA6U7HU__"